/**
 * Small unit-conversion/formatting helpers for showing physical measurements in more than one
 * unit at once — e.g. DIS decoration-placement data is always millimeters, while size chart data
 * (resolved from the product's own attribute model, see
 * `src/pages/editor/components/decorationSpecs/productPropertySizeChart.ts`) is in whatever unit that
 * property declares (commonly inches or centimeters). Showing both lets a designer
 * cross-reference either section without doing the conversion mentally.
 */

export const MM_PER_INCH = 25.4;

export function mmToInches(mm: number): number {
    return mm / MM_PER_INCH;
}

export function inchesToMm(inches: number): number {
    return inches * MM_PER_INCH;
}

export function formatMm(mm: number, fractionDigits = 1): string {
    return `${mm.toFixed(fractionDigits)} mm`;
}

export function formatInches(inches: number, fractionDigits = 2): string {
    return `${inches.toFixed(fractionDigits)} in`;
}

/** e.g. `50 mm (1.97 in)` — used for DIS decoration-placement values, which are always mm-native. */
export function formatMmWithInches(mm: number): string {
    return `${formatMm(mm)} (${formatInches(mmToInches(mm))})`;
}
